<template>
  <template v-if="load === 'success'">
    <table class="plc-table">
      <tr class="plc-table__header">
        <th class="hidden-md-up"></th>
        <th class="plc-table__headerCell hidden-sm-only rank">Rank</th>
        <th class="plc-table__headerCell hidden-sm-only">Address</th>
        <th class="plc-table__headerCell hidden-sm-only">Quantity</th>
        <th class="plc-table__headerCell hidden-sm-only">Percentage</th>
      </tr>
      <holders-table-row v-for="holder in holders" :key="holder.rank" :row="holder" />
    </table>

    <gl-loader-lazy v-if="false" />
  </template>
  <gl-loader v-else />
</template>

<script>
import HoldersTableRow from './components/HoldersTableRow'
import GlLoader from '@gl/GlLoader'
import GlLoaderLazy from '@gl/GlLoaderLazy'

export default {
  name: 'HoldersTable',
  components: { GlLoaderLazy, GlLoader, HoldersTableRow },
  data() {
    return {
      load: 'loading',
      holders: [
        // {
        //   rank: '1',
        //   address: 'P4uTsE9CFkhRYVqtV3uiLd5LcovvuXUCMW9n',
        //   quantity: '45321.06692271 PLC',
        //   percentage: '35.0000%',
        // },
        // {
        //   rank: '2',
        //   address: 'P4uTsE9CFkhRYVqtV3uiLd5LcovvuXUCMW9n',
        //   quantity: '45321.06692271 PLC',
        //   percentage: '6.6051%',
        // },
        // {
        //   rank: '3',
        //   address: 'P4uTsE9CFkhRYVqtV3uiLd5LcovvuXUCMW9n',
        //   quantity: '45321.06692271 PLC',
        //   percentage: '35.0000%',
        // },
      ],
    }
  },
  async created() {
    await new Promise(resolve => setTimeout(resolve, 1000))
    this.load = 'success'
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/blocks/table';

.rank {
  @media (min-width: $breakpoint-md) {
    width: 1%;
  }

  @media (min-width: $breakpoint-xl) {
    width: auto;
  }
}
</style>
